import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=447a7911&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=ts"
export * from "./FeedbackList.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=447a7911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a7911",
  null
  
)

export default component.exports